import { Section, stagger } from "./Section";

const REASONS = [
  ["Grounded in the Philippines", "We work close to the sites, the project teams and the local interfaces that influence delivery."],
  ["Senior project experience", "The ALS team brings practical experience across development, construction, QA/QC, grid connection, project controls and commissioning."],
  ["The right expertise for the project", "We maintain a lean core team and work with engineering, technical and technology specialists appropriate to each assignment, allowing deeper capability to be brought in where the project requires it."],
];

const AUDIENCES = [
  "Developers",
  "Asset Owners",
  "Investors & Lenders",
  "EPC Contractors",
  "International engineering firms",
  "International companies exploring the Philippines market",
];

export const WhyAls = () => (
  <Section id="why-als" className="bg-white" testId="why-als-section">
    <div className="grid gap-10 lg:grid-cols-[0.32fr_0.68fr] lg:gap-16">
      <h2 className="als-heading self-start" data-testid="section-heading-why-als">Why ALS</h2>
      <div>
        {REASONS.map(([h, t], i) => (
          <article key={h} className={`reveal-item py-10 ${i === 0 ? "pt-0" : "border-t border-[#1B3A6B]/15"}`} style={stagger(i)} data-testid={`why-als-card-${i + 1}`}>
            <h3 className="text-[16px] font-medium text-[#1B3A6B]">{h}</h3>
            <p className="mt-2 text-[15px] leading-[1.7] text-[#4A5568]">{t}</p>
          </article>
        ))}
      </div>
    </div>
  </Section>
);

export const Audiences = () => (
  <Section id="who-we-work-with" className="bg-navy-dots" testId="audiences-section">
    <h2 className="als-heading is-centered text-center" data-testid="section-heading-who-we-work-with">Who we work with</h2>
    <ul className="mx-auto mt-8 grid max-w-[900px] gap-x-12 gap-y-10 sm:grid-cols-2 lg:grid-cols-3" data-testid="audiences-list">
      {AUDIENCES.map((a, i) => (
        <li key={a} className="audience-item reveal-item" style={stagger(i)} data-testid={`audience-card-${i + 1}`}>{a}</li>
      ))}
    </ul>
  </Section>
);
